<template></template>
<script setup>
import { onMounted } from 'vue'

const props = defineProps({ images: { type: Array } })

onMounted(async () => {
	const promises = props.images.map((url) => {
		return new Promise((resolve) => {
			const img = new Image()
			img.src = url
			img.onload = resolve
		})
	})

	await Promise.all(promises)
})
</script>
